import React from "react";
import {
  ItemContainer,
  ItemDetails,
  Details,
  ImgDetails,
  Title,
  StatusCollor,
  MiddleMobile,
} from "~/pages/GasVoucherList/styles";
import information from "~/assets/images/information.svg";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

export default function Item({ voucher }) {
  const history = useHistory();
  const dispatch = useDispatch();

  function selectVoucher() {
    dispatch({
      type: "VOUCHER_SELECTED",
      voucher: voucher,
    });
    history.push("/valegas/view");
  }

  return (
    <ItemContainer>
      <Title>Código De Autorização: {voucher.authorizationCode}</Title>

      <ItemDetails desktop style={{ marginRight: "11rem" }}>
        <div className="d-flex align-items-center">
          <StatusCollor
            style={{ marginTop: -3 }}
            status={voucher.status}
          ></StatusCollor>
          {voucher.status}
        </div>
      </ItemDetails>

      <ItemDetails onClick={() => selectVoucher()} desktop>
        <Details>
          Detalhes
          <ImgDetails src={information} alt="Ícone de informações" />
        </Details>
      </ItemDetails>

      <MiddleMobile>
        <ItemDetails>
          <div className="align">
            <StatusCollor status={voucher.status}></StatusCollor>
            {voucher.status}
          </div>
        </ItemDetails>

        <ItemDetails onClick={() => selectVoucher()}>
          <Details>
            Detalhes
            <ImgDetails src={information} alt="Ícone de informações" />
          </Details>
        </ItemDetails>
      </MiddleMobile>
    </ItemContainer>
  );
}
